import { useEffect } from 'react'
import {
  SET_UNIVERSAL_NOTIFICATION_MODAL_CONFIG_EVENT,
  SHOW_UNIVERSAL_NOTIFICATION_MODAL_EVENT,
} from 'shared/constants'
import { useFeature } from 'flagged'
import GiftManagementFeedbackModal from './GiftManagementFeedbackModal'
import { Responses } from '../../global'

const GIFT_MANAGEMENT_FEEDBACK_MODAL_LOCAL_STORAGE_KEY =
  'GiftManagementFeedbackModalNotificationDismissed'

interface DisplayGiftManagementFeedbackModalProps {
  registry: Responses.Registry
  eventLocation: string
}

const openGiftManagementFeedbackModal = ({
  registry,
  eventLocation,
}: DisplayGiftManagementFeedbackModalProps) => {
  // Delay opening of modal for 1 second
  setTimeout(() => {
    PubSub.publish(SET_UNIVERSAL_NOTIFICATION_MODAL_CONFIG_EVENT, {
      renderContent: (cm: () => void) => (
        <GiftManagementFeedbackModal
          closeModal={cm}
          eventLocation={eventLocation}
          registry={registry}
        />
      ),
      onModalOpen: () =>
        localStorage.setItem(
          GIFT_MANAGEMENT_FEEDBACK_MODAL_LOCAL_STORAGE_KEY,
          'true'
        ),
    })
    PubSub.publish(SHOW_UNIVERSAL_NOTIFICATION_MODAL_EVENT)
  }, 1_000)
}

export default ({
  registry,
  eventLocation,
}: DisplayGiftManagementFeedbackModalProps) => {
  const isGiftManagementFeedbackModalEnabled = useFeature(
    'show_gift_management_feedback_modal'
  )

  useEffect(() => {
    if (!window) return

    const isDismissed = localStorage.getItem(
      GIFT_MANAGEMENT_FEEDBACK_MODAL_LOCAL_STORAGE_KEY
    )

    if (
      isGiftManagementFeedbackModalEnabled &&
      !isDismissed &&
      registry?.type !== 'holiday' &&
      registry?.type !== 'birthday'
    ) {
      openGiftManagementFeedbackModal({ registry, eventLocation })
    }
  }, [isGiftManagementFeedbackModalEnabled])

  return null
}
